/**
 * The ``app`` function returns the fully qualified path to the app directory.
 * You may also use the ``app`` function to generate a fully qualified path
 * to a given file relative to the application directory.
 */

export const app = (path = '') => process.env.REACT_APP_ZERA_API + path

/**
 * Create a URL for an entity using the current schema of the request.
 * Indicates the static folder.
 */

export const assets = (path = '') => app('/static') + path

/**
 * The ``storage`` function returns the full
 * path of the file server directory.
 */

export const storage = (path = '') => process.env.REACT_APP_ZERA_STORAGE + path

export const getDictionaryValue = (key: any) => {
  try {
    let list
    try {
      list = JSON.parse(localStorage.getItem('lang-dictionary') || '')
    } catch (error) {
      window.location.reload()
    }

    if (!list || list.length < 1) {
      window.location.reload()
    }

    const value = list.find((item: any) => item.key === key).value

    return value
  } catch (error) {
    return '$$' + key + '$$'
  }
}
